import { initializeApp } from 'firebase/app'

const firebaseConfig = {
    apiKey: 'AIzaSyB7MXRf108HxiUpA_S5scgH7GUQFia03vQ',
    authDomain: 'martonticket.firebaseapp.com',
    projectId: 'martonticket',
    storageBucket: 'martonticket.appspot.com',
    messagingSenderId: '1013319352512',
    appId: '1:1013319352512:web:4f1e6712093100dbf56d25',
}

const firebaseApp = initializeApp(firebaseConfig)

export { firebaseApp }
